import { useState } from 'react';
import { useSelector } from 'react-redux';
import styles from '../editPost.module.css';

export default function ChangeRequestEdit({
	changeRequestMessage,
	changeRequested,
	createdBy,
	metadata,
}) {
	const { user } = useSelector(({ user }) => user);
	const [shortMessage, setShortMessage] = useState(true);

	const onHandleLength = (bool) => {
		setShortMessage(bool);
	};

	const isOriginalCreator =
		user.id === createdBy || user.id === metadata?.createdBy;

	return isOriginalCreator && changeRequested ? (
		<div className={styles.changeRequestMessageRoot}>
			<div className={styles.changeRequestMessageTitle}>Requested Changes</div>
			<div className={styles.changeRequestMessageBody}>
				{changeRequestMessage && changeRequestMessage.length > 300 ? (
					changeRequestMessage &&
					changeRequestMessage.length >= 300 &&
					shortMessage ? (
						<>
							{changeRequestMessage.substring(0, 300)}
							<span
								className={styles.changeRequestMessageSeeMore}
								onClick={() => onHandleLength(false)}>
								...See More
							</span>
						</>
					) : (
						<>
							{changeRequestMessage}
							<span
								className={styles.changeRequestMessageSeeMore}
								onClick={() => onHandleLength(true)}>
								...See Less
							</span>
						</>
					)
				) : (
					changeRequestMessage
				)}
			</div>
		</div>
	) : null;
}
